<script setup>
import ClassroomProgram from './ClassroomProgram.vue';

const GRADES = ['Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6', 'Kinder 1', 'Kinder 2'];
</script>

<template>
  <ClassroomProgram :grades="GRADES" />
</template>
